<template>
  <RemotePaginatedList :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       data-url="payment/admin/payment_record/"
                       data-key="records"
                       :extra-params="{'user_id': userId}"
                       v-bind="$attrs">
    <template #item.create_at="{value}">
      {{ $parseDate(value) }}
    </template>
    <template #item.payment_type="{value}">
      {{ $t(`payment_type.${value}`) }}
    </template>
    <template #item.payment_method="{value}">
      {{ $t(`payment_method.${value}`) }}
    </template>
    <template #item.ref_no="{item}">
      {{ $getPaymentRecordRefNo(item) }}
    </template>
    <template #item.card_no="{item}">
      {{ $getPaymentRecordCardNo(item) }}
    </template>
    <template #item.total="{item}">
      {{ $getPaymentRecordTotal(item) }}
    </template>
    <template #item.status="{item}">
      {{ $getPaymentRecordStatus(item) }}
    </template>
  </RemotePaginatedList>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faCalendarCheck, faCalendarTimes, faEdit, faSearch} from '@fortawesome/free-solid-svg-icons'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {computed, ref} from "@vue/composition-api";

library.add(faEdit, faSearch, faCalendarCheck, faCalendarTimes);

export default {
  name: 'AdminPaymentRecordList',
  components: {RemotePaginatedList},
  props: {
    userId: String,
  },
  setup(props, {root, emit}) {
// Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_payment.create_at'), value: 'create_at', date_range: true},
        // {
        //   text: root.$t('admin_payment.payment_method'), value: 'payment_method',
        //   options: [
        //     {text: root.$t('payment_method.cyber_source'), value: PAYMENT_METHOD.CYBER_SOURCE},
        //     {text: root.$t('payment_method.union_pay'), value: PAYMENT_METHOD.UNION_PAY},
        //     {text: root.$t('payment_method.point'), value: PAYMENT_METHOD.POINT},
        //   ]
        // },
        {
          text: root.$t('admin_payment.payment_type'), value: 'payment_type',
          options: [
            {text: root.$t('payment_type.acc_facility_booking'), value: 'acc_facility_booking'},
            {text: root.$t('payment_type.acc_membership_extend'), value: 'acc_membership_extend'},
          ]
        },
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_payment.create_at'), value: 'create_at'},
      {text: root.$t('admin_payment.payment_type'), value: 'payment_type'},
      {text: root.$t('admin_payment.payment_method'), value: 'payment_method'},
      {text: root.$t('admin_payment.ref_no'), value: 'ref_no', sortable: false},
      {text: root.$t('admin_payment.card_no'), value: 'card_no', sortable: false},
      {text: root.$t('admin_payment.status'), value: 'status', sortable: false},
      {text: root.$t('admin_payment.total'), value: 'total', sortable: false},

      {text: '', value: 'actions', sortable: false, width: 200},
    ]);

    return {
      filterOptions,
      headers,
    }
  },
}
</script>
